import TextCTA from './TextCTA.js';
export { default } from './TextCTA.js';
//# sourceMappingURL=index.js.map
